export const STORAGE_KEYS = {
    CURTAIN_RAISER: "curtain_raiser_shown",
    MENU_RESPONSE: "menu_response",
    RESTAURANT_CONFIG: "restaurant_config",
    LOCAL_CART: "local_cart",
    POPUP_WIDGET_SHOWN: "popup_widget_shown",
    PAYMENT_PENDING_PARAMS: "payment_pending_params",
    CART_INSTRUCTION_TOOLTIP_SHOWN: "cart_instruction_tooltip_shown",
    TABLE_CONFIG: "table_config",
    PARENT_ORDER_ID: "parent_order_id",
    SHOW_BACK: "show_back",
    HIDE_BOTTOM_BAR: "hide_bottom_bar",
    FORCE_FETCH_CONFIG: "force_fetch_config",
    CROSS_SELL_FREQ: "cross_sell_freq",
};
